import React from 'react';
import { Card, Col, Container, Row } from 'reactstrap';

// Import Images
import createTemplate from "../../assets/images/gallium/create-template.jpg";
import selectTemplate from "../../assets/images/gallium/select-template.jpg";

import FeatherIcon from 'feather-icons-react/build/FeatherIcon';

const Templates = () => {
    return (
        <React.Fragment>

            <section className="section pt-4 pb-4" id="templates">
                <Container>
                    <Row className="align-items-center gy-4 mb-5">
                        <Col lg={6} className="order-2 order-lg-1">
                            <div className="text-muted">
                                <h5 className="fs-12 text-uppercase text-info">Template Library</h5>
                                <h4 className="mb-3">Images at the Ready</h4>
                                <p className="mb-4 ff-secondary">Popular Linux distributions are available to deploy with a single click. Windows Images are built from your media. Never upload an ISO by hand again. </p>

                                <Row>
                                    <Col sm={12}>
                                        <div className="vstack gap-2">
                                            <div className="d-flex">
                                                <div className="flex-shrink-0 me-3">
                                                    <FeatherIcon icon="package" className="icon-dual-info" />
                                                </div>
                                                <div className="flex-grow-1">
                                                    <h5 className="fs-14 mb-3 mt-2">Use our Images or Bring Your Own</h5>
                                                    <p className='text-muted'>Add your own Machine Images to the Template Library and we’ll distribute them to each Hypervisor on demand. </p>
                                                </div>
                                            </div>
                                            <div className="d-flex">
                                                <div className="flex-shrink-0 me-3">
                                                    <FeatherIcon icon="terminal" className="icon-dual-info" />
                                                </div>
                                                <div className="flex-grow-1">
                                                    <h5 className="fs-14 mb-3 mt-1">Script Injection</h5>
                                                    <p className='text-muted'>The Cloudinit Service allows you to securely pass configuration and scripts to VMs, even when isolated from the Internet.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                    
                                </Row>
                            </div>
                        </Col>

                        <Col lg={6} sm={7} className="col-10 ms-auto order-1 order-lg-2 d-none d-lg-block">
                            <div>
                                <img src={createTemplate} alt="" className="img-fluid img-thumbnail rounded create-template"/>
                            </div>
                            <Card className="card-bg-fill rounded shadow-lg d-none d-lg-block select-template-box">
                                <img className="card-img img-fluid" src={selectTemplate} alt="Card cap">
                                </img>
                            </Card>
                        </Col>

                        <Col lg={6} sm={7} className="col-10 mx-auto order-1 order-lg-2 d-block d-lg-none">
                            <div>
                                <img src={selectTemplate} alt="" className="img-fluid img-thumbnail mx-auto rounded "/>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default Templates;